import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { setSubChildId } from "Administrator/modules/AdministratorModule";
import StandardDescriptionMapping from "./routes/StandardDescriptionMapping";

export default store => ({
  path: "scales-and-descriptors",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter() {
    store.dispatch(setSubChildId("GRADE_SCALES_AND_DESCRIPTORS"));
  },
  onLeave() {
    store.dispatch(setSubChildId(""));
  },
  childRoutes: [StandardDescriptionMapping(store)],
});
